const routesPaths = {
  notFound: '/404',
  home: '/',
  category: '/category',
  product: '/product',
  certification: '/certification',
  issueRequest: '/issue-request',
  success: '/certification/success',
  contactUs: '/contact-us',
  privacyPolicy: '/privacy-policy',
  sho: '/sho',
  bag: '/bag',
  bagMaroquinerie: '/bag/maroquinerie',
  pap: '/pap',
};

export default routesPaths;
